<form class="form-inline">
  <div class="form-group mx-sm-3 mb-2">
    <label style="margin-right: 20px">Tolérance (%)</label>
    <input type="number" class="form-control"  name="speed" [(ngModel)]="speedAlertConfiguration.value1" style="width: 60px;border-radius: 10px;font-size: 12px">
  </div>

  <!-- ✅ Guard ajouté ici -->
  <app-email-manager
    *ngIf="alert"
    [enableGlobalConfigToAllVehicules]="enableGlobalConfigToAllVehicules"
    [emailMode]="alert.emailMode"
    [enableGlobalConfig]="enableGlobalConfig"
    [emailsHash]="alert.emails"
    (onChange)="emailSettings($event)">
  </app-email-manager>

  <br>

  <div class="form-group">
    <label>Activer l'alert</label>
    <div class="input-group">
      <!-- ✅ Guard ajouté ici -->
      <mat-slide-toggle *ngIf="alert" [(ngModel)]="alert.isActive" name="isActive"></mat-slide-toggle>
    </div>
  </div>




  <div>

    <div style="margin: 10px 0 10px 0" *ngIf="!showAdvancedSettings" (click)="collapseAdvancedSettings()">
      <i class="fa fa-plus-square"></i>
      <span class="link">paramétrage avancé</span>
    </div>

    <div style="margin: 10px 0 10px 0" *ngIf="showAdvancedSettings" (click)="collapseAdvancedSettings()">
      <i class="fa fa-minus-square"></i>
      <span class="link">masquer paramétrage avancé</span>
    </div>

    <app-cron-settings *ngIf="showAdvancedSettings" [cron]="cronAlertConfiguration"></app-cron-settings>

  </div>

  <button type="submit" class="btn btn-flat btn-primary pull-right" style="margin-top: 45px;" (click)="save()">
    Sauvegarder
  </button>
</form>

<ngx-loading [show]="loader" [config]="{ backdropBorderRadius: '0px',fullScreenBackdrop:true }"></ngx-loading>
